jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

      var header = document.querySelector('.t4s-header__wrapper');
      var logo = document.querySelector('.header__normal-logo');

     logo.style.transition = 'transform 0.3s ease-out';
  
     window.addEventListener("scroll", function() {
          if (window.scrollY >= 30) {
            header.style.position = 'fixed';
            header.style.top = '0';
            header.style.left = '0';
            header.style.width = '100%';
            header.style.zIndex = '99';
            header.style.borderBottom = '1px solid #7a7b80';
            header.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.1)';
            logo.style.transform = 'scale(0.8)';
            logo.style.paddingTop = '15px';
          } else {
            header.style.position = 'relative';
            header.style.top = '';
            header.style.left = '';
            header.style.width = '';
            header.style.zIndex = '';
            header.style.borderBottom = '';
            header.style.boxShadow = '';
            logo.style.transform = 'scale(1)';
            logo.style.paddingTop = '';
          }
    });


});

  